import type { ICommonContext } from '~/entities/auth/model/store/access'

import { SurveyModuleSlugEnum } from '~/shared/const'
import { permissions } from '~/shared/lib'

export type AccessFunction = [permission: string, ctx?: Partial<ICommonContext> | null, isBackend?: boolean]

export interface ISubModuleConfig {
  submodulePermissions: {
    PERMISSION: string
    ROUTE: string
    CREATE: { PERMISSION: string, ROUTE: string }
    EDIT: { PERMISSION: string, ROUTE: string }
    FILL: { PERMISSION: string, ROUTE: string }
    STATISTICS: {
      PERMISSION: string
      ROUTE: string
      GENERAL: { PERMISSION: string, ROUTE: string }
      PRIVATE: {
        PERMISSION: string
        ROUTE: string
        USER: {
          PERMISSION: string
          ROUTE: string
          RESPONSE: {
            PERMISSION: string
            ROUTE: string
          }
        }
      }
    }
    SHOW_SHARE_LINK_BTN: { PERMISSION: string }
    SHOW_EDIT_LINK_BTN: { PERMISSION: string }
    SHOW_ARCHIVE_LINK_BTN: { PERMISSION: string }
    SHOW_CREATE_SURVEY_BTN: { PERMISSION: string }
    SHOW_STATISTICS_TAB: { PERMISSION: string }
    SHOW_ARCHIVE_TAB: { PERMISSION: string }
  }
  title: string
  moduleSlug: SurveyModuleSlugEnum
  access: {
    showCreateSurveyBtn: AccessFunction
    showShareLinkBtn: AccessFunction
    showArchiveTab: AccessFunction
    showStatisticsTab: AccessFunction
  }
}

export const SURVEYS_SUBMODULE_CONFIG = {
  WORKSPACE: {
    submodulePermissions: permissions.PROJECTS.WORKSPACE.SURVEYS,
    title: 'Опросы',
    moduleSlug: SurveyModuleSlugEnum.ProjectSurvey,
    access: {
      showCreateSurveyBtn: [permissions.PROJECTS.WORKSPACE.SURVEYS.SHOW_CREATE_SURVEY_BTN.PERMISSION, null, true],
      showShareLinkBtn: [permissions.PROJECTS.WORKSPACE.SURVEYS.SHOW_SHARE_LINK_BTN.PERMISSION, null, true],
      showArchiveTab: [permissions.PROJECTS.WORKSPACE.SURVEYS.SHOW_ARCHIVE_TAB.PERMISSION, null, true],
      showStatisticsTab: [permissions.PROJECTS.WORKSPACE.SURVEYS.SHOW_STATISTICS_TAB.PERMISSION, null, true],
    },
  } as ISubModuleConfig,
  QUESTION_TO_DEPUTY: {
    submodulePermissions: permissions.PROJECTS.WORKSPACE.QUESTION_TO_DEPUTY,
    title: 'Написать обращение',
    moduleSlug: SurveyModuleSlugEnum.QuestionToDeputy,
    access: {
      showCreateSurveyBtn: [permissions.PROJECTS.WORKSPACE.QUESTION_TO_DEPUTY.SHOW_CREATE_SURVEY_BTN.PERMISSION],
      showShareLinkBtn: [permissions.PROJECTS.WORKSPACE.QUESTION_TO_DEPUTY.SHOW_SHARE_LINK_BTN.PERMISSION],
      showArchiveTab: [permissions.PROJECTS.WORKSPACE.QUESTION_TO_DEPUTY.SHOW_ARCHIVE_TAB.PERMISSION],
      showStatisticsTab: [permissions.PROJECTS.WORKSPACE.QUESTION_TO_DEPUTY.SHOW_STATISTICS_TAB.PERMISSION],
    },
  } as ISubModuleConfig,
}
